export const WEBSOCKET_API = "ws://demo.api.hfyefan.cn:8383/ws";
// 设备类型
export const deviceType = {
	SERVER : 0,	//服务器
    PC: 1, //PC
	H5: 2, //H5
	APP: 3, //APP
	APP_ANDROID: 4, //ANDROID
	APP_IOS: 5, //IOS
	WXAPP: 6, //WXAPP
}
// 请求类型
export const actionType = {
	REQUESTMSG:1,//"请求消息"  //请求服务器的消息
	RESPONSEMSG:2,//"响应消息"  //服务器响应的消息
	FRIENDMSG:3,//"好友消息"  //上线推送离线消息
	GROUPMSG:4,//"群组消息"  //上线推送离线消息
	ROOMMSG:5,//"聊天室消息"  //上线不推送离线消息
	SYSMSG:6,//"系统消息");//上线推送离线消息
}
// 消息类型
export const messageType = {
	// 请求消息类型
	CONNECT:1,//"连接服务器"
	HEARTBEAT:2,//"客户端心跳"
	// 响应消息类型
	CONNECTED:1,//"服务器连接成功"
	HEARTBEATOK:2,//"心跳正常"
	UNKNOWNERROR:3,//"未知错误"
	FORMATERROR:4,//"消息格式错误"
	UNAUTH:5,//"您还未鉴权"
	DEVICEERROR:6,//"设备类型不支持"
	AUTHERROR:7,//"与服务器鉴权失败"
	BREAKOFF:8,//"账号在其他地方登陆"
	CANNOTSPEAK:9,//"您已被禁言"
	NOTFRIEND:10,//"不是好友关系"
	SENDSUCCESS:11,//"消息发送成功"
	// 好友消息类型
	TEXT: 1,//"文本消息"
	IMAGE: 2,//"图片消息"
	AUDIO: 3,//"音频消息"
	VIDEO: 4,//"视频消息"
	LOCATION: 5,//"位置消息"
	REDPACKET: 6,//"红包消息"
	TRANSFER: 7,//"转账消息"
	CARD: 8,//"名片消息"
	FILE: 9,//"文件消息"
	URL: 10,//"网址消息"
	PRODUCT: 11,//"商品消息"
	ORDER: 12,//"订单消息"
	OFFLINEMSG: 13,//"离线消息"
	//handle message
	MSGSIGNED: 51,//"签收成功消息"
	WITHDRAW: 52,//"撤回消息"
	ADDFRIEND: 53,//"添加好友请求"
	ACCEPT: 54,//"接受好友添加"
	REFUSE: 55,//"拒绝好友添加"
	INVITE: 56,//"邀请好友进群"
	APPLYGROUP: 57,//"申请加入群"
	APPLYACCEPT: 58,//"群管理员同意加入"
	APPLYREFUSE: 59,//"群管理员拒绝加入");


	// TEXT:1,//"文本消息"
	// IMAGE:2,//"图片消息"
	// AUDIO:3,//"音频消息"
	// VIDEO:4,//"视频消息"
	// LOCATION:5,//"位置消息"
	// REDPACKET:6,//"红包消息"
	// TRANSFER:7,//"转账消息"
	// CARD:8,//"名片消息"
	// FILE:9,//"文件消息"
	// URL:10,//"网址消息"
	// PRODUCT:11,//"商品消息"
	// ORDER:12,//"订单消息"
	// MSGSIGNED:13,//"签收成功消息"
	// WITHDRAW:14,//"撤回消息"
	// ADDFRIEND:15,//"添加好友请求"
	// ACCEPT:16,//"接受好友添加"
	// REFUSE:17,//"拒绝好友添加"
	// INVITE:18,//"邀请好友进群"
	// APPLYGROUP:19,//"申请加入群"
	// APPLYACCEPT:20,//"群管理员同意加入"
	// APPLYREFUSE:21,//"群管理员拒绝加入"
}